import { createSlice } from "@reduxjs/toolkit";


const utilsSlice = createSlice({
	name: "utils",
	initialState: {
		scanOpen: false,
		listSetupOpen: false,
		savedListsOpen: false,
		tariffyOpen: false,
	},
	reducers: {
		openScanner(state) {
			state.scanOpen = true;
		},
		closeScanner(state) {
			state.scanOpen = false;
		},
		openListSetup(state) {
			state.listSetupOpen = true;
		},
		closeListSetup(state) {
			state.listSetupOpen = false;
		},
		openSavedLists(state) {
			state.savedListsOpen = true;
		},
		closeSavedLists(state) {
			state.savedListsOpen = false;
		},
		openTariffy(state) {
			state.tariffyOpen = true;
		},
		closeTariffy(state) {
			state.tariffyOpen = false;
		},
	},
});


export const {
	openScanner,
	closeScanner,
	openListSetup,
	closeListSetup,
	openSavedLists,
	closeSavedLists,
	openTariffy,
	closeTariffy,
} = utilsSlice.actions;

export default utilsSlice.reducer;